// These styles will be used by React-To-Print to print the label preview.
const cssString = `
/**
 * Resets the default browser margin such that it is consistent across all the browsers
 */
@page {
	margin: 0 !important;
}

html, body {
	height: 100vh; /* Use 100% here to support printing more than a single page */
	margin: 0 !important;
	padding: 0 !important;
	overflow: hidden;
}

body {
	/**
	 * Allow multiple pages to print in Edge
	 */
	overflow: visible !important;

	/**
	 * Overrides to keep the image within the boundaries of the sheet.
	 * Firefox allows image scaling only if the overflow property is hidden.
	 */
}

body .windows.chrome,
body .windows.ie,
body .windows.edge {
	overflow: visible !important;
}

body .windows.firefox {
	overflow: hidden !important;
}

body .macos.safari {
	overflow: hidden !important;
}`;

export default cssString;
